// src/index.js
import "./css/tailwind.css";
import "./scss/global.scss";
import "./js/global";
